import { Card, Flex, Icon, InfoBlock } from '@sendoutcards/quantum-design-ui'
import { Icon as DSIcon } from '../../../../../design_system/atoms/icons/components/Icon'
import React from 'react'
import { SponsorFragment } from 'src/graphql/generated/graphql'
import { SponsorCard } from 'src/onboarding/components/SponsorCard'
import { sendoutcardsPromotionsGenealogyId } from 'src/app/constants'

type SponsorTileProps = {
  sponsor?: SponsorFragment
  isAffiliateJoining?: boolean
  onOpenSearch: () => void
  onOpenInfoModal?: () => void
}

export const SponsorTile = (props: SponsorTileProps) => {
  const { sponsor, isAffiliateJoining, onOpenSearch, onOpenInfoModal } = props
  return (
    <Flex width="100%">
      {sponsor && sponsor.genealogyId !== sendoutcardsPromotionsGenealogyId ? (
        <SponsorCard
          sponsor={sponsor}
          onClick={onOpenSearch}
          backgroundColor="#f5f6f7"
          isActive
        />
      ) : (
        <Card
          width="100%"
          borderRadius="medium"
          inset="x2"
          cursor="pointer"
          backgroundColor="#f5f6f7"
        >
          <Flex
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            onClick={onOpenSearch}
          >
            <Flex alignItems="center">
              <span
                style={{
                  boxShadow: 'box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;',
                  display: 'flex',
                  borderRadius: '50%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#f0f0f0',
                  padding: '12px',
                  marginRight: '5px',
                }}
              >
                <DSIcon size={30} name="soc_mini_logo" color="#7f1fdc" />
              </span>
              <InfoBlock
                size="small"
                heading={
                  isAffiliateJoining
                    ? 'Who introduced you to our products?'
                    : 'Someone show you this product?'
                }
                caption="Optional"
              />
            </Flex>
            <span
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
              }}
              onClick={e => {
                e.stopPropagation()
                onOpenInfoModal?.()
              }}
            >
              <Icon
                name="plus"
                primaryColor="primaryHeadingText"
                size="small"
              />
            </span>
          </Flex>
        </Card>
      )}
    </Flex>
  )
}
